import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import propTypes from 'prop-types';
import classNames from 'classnames';
import ReactLoading from 'react-loading';
import Icon from '../../PagePaymentResult/Icon';
import Loading from '../../PageInvoice/Detail/Invoice/Midtrans/Loading';
import VANumberPlaceholder from '../../PageInvoice/Detail/Invoice/Midtrans/VANumberPlaceholder'
import ButtonSnapPay from '../../Forms/ButtonSnapPay';
import { withRouter } from "react-router-dom"
import ModalOutOfStock from '../../Modals/ModalOutOfStock';
import moment from 'moment';
import { doGetMidtransPaymentDetail } from '../../../actions/paymentAction';
import { getStatusText, getStatusDetailText, getSelectedPayment } from '../../../helpers/snap';
import CloseIcon from '../../../images/close-button-white.png';
import { convertToRupiah } from '../../../utils';
import ButtonCopy from '../../Forms/ButtonCopy';

import CircleCloseButton from "../../../images/circle-close-button.png";
import RoundCloseButton from "../../../images/round-close-button.png";
import CopyIcon from "../../../images/copyIcon.png";
import WarningGreen from "../../../images/warning-green.png";

moment.locale("en");

const NOT_CONFIRM_PAYMENT_MSG = 'Continue Your Payment';

const HAS_CONFIRM_PAYMENT_MSG = 'See Instructions';

const CloseButton = props => (
  <div style={{ display: 'block', position: 'relative', top: 0 }}>
    <KickImage src={CloseIcon} onClick={props.onClick} style={{ width: '15px', position: 'absolute', right: 15, top: 15, cursor: 'pointer' }} />
  </div>
)

class ModalSnapPay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _trxId: null,
      _trxToken: null,
      _paymentType: 'bank_transfer',
      _bank: null,
      _vaNumber: null,
      _expiredAt: null,
      _trxStatus: 'pending',
      _statusCode: 0,
      _isOpenAlert: false,
      _amount: 0
    }
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      await this.setState({
        _trxId: this.props.trxId,
        _trxToken: this.props.trxToken,
        _paymentType: this.props.paymentType,
        _expiredAt: this.props.expiredAt,
        _bank: this.props.bank,
        _isOpenAlert: false
      })
      if (this.props.trxToken && this.props.autoOpenSnapModal) {
        this.buttonPayRef._handleOpenSnap()
      }
      this.props.getMidtransDetail(this.props.invoiceNumber)
    }

    if (prevProps.dataMidtrans.isFetch && !this.props.dataMidtrans.isFetch) {
      const { error, data } = this.props.dataMidtrans;
      if (!error) {
        this.setState({
          _trxId: data.transaction_id,
          _trxToken: data.transaction_token,
          _paymentType: data.payment_type,
          _bank: ['bank_transfer', 'echannel'].includes(data.payment_type) ? data.va_type : null,
          _vaNumber: ['bank_transfer', 'echannel'].includes(data.payment_type) ? data.va_number : null,
          _expiredAt: data.expired_at,
          _trxStatus: data.is_expired ? 'expire' : data.status,
          _statusCode: data.status_code,
          _amount: data.gross_amount
        })
      }
      else {
        const { status_code } = error;
        this.setState({
          _trxStatus: 'failure',
          _statusCode: status_code
        })
      }
    }
  }

  _handleOnSuccess = success => {
    if(this.props.pageSelling){
      const queryStr = success.finish_redirect_url.split("/payments/results")
      this.props.onSuccessTopUp(`/payments/results${queryStr[1]}`)
    } else {
      const queryStr = success.finish_redirect_url.split("/payments/results")
      this.props.history.replace(`/payments/results${queryStr[1]}`)
      // window.location = success.finish_redirect_url;
    }
  }

  _handleOnPending = pending => {
    const {
      transaction_id,
      payment_type,
      va_numbers,
      permata_va_number,
      bni_va_number,
      bca_va_number,
      bill_key,
      biller_code
    } = pending;
    let { _vaNumber, _trxId, _bank } = this.state;
    if (transaction_id) {
      _trxId = transaction_id;
    }
    if (payment_type === 'echannel') {
      _vaNumber = `${biller_code} ${bill_key}`;
      _bank = 'MANDIRI';
    }
    else {
      if (va_numbers && va_numbers.length) {
        _vaNumber = va_numbers[0].va_number;
        _bank = va_numbers[0].bank.toUpperCase();
      }
      else if (permata_va_number) {
        _vaNumber = permata_va_number;
        _bank = 'PERMATA';
      }
      else if (bni_va_number) {
        _vaNumber = bni_va_number;
        _bank = 'BNI';
      }
      else if (bca_va_number) {
        _vaNumber = bca_va_number;
        _bank = 'BCA';
      }
    }
    this.setState({
      _trxId,
      _bank,
      _vaNumber
    })
  }

  _handleOnError = e => {
    const { status_code } = e;
    this.setState({
      _trxStatus: parseInt(status_code) === 407 ? 'expire' : 'failure',
      _statusCode: status_code
    })
  }

  _handleExpiredCountdown = () => {
    const { _vaNumber } = this.state;
    this.setState({
      _trxStatus: 'expire',
      _vaNumber: _vaNumber && _vaNumber.split('').map((c, index) => {
        if (index > 2) return 'X';
        return c;
      }).join('')
    })
  }

  _handleOnToggleAlert = () => {
    this.setState({ _isOpenAlert: !this.state._isOpenAlert })
  }

  _handleOnSubmitAlert = async (e) => {
    await this._handleOnToggleAlert();
    this.buttonPayRef._handleOpenSnap()
  }

  _deleteAmountBeforeClose = () => {
    if (this.props.isOpen && this.props.deleteAllAmount) {
      this.props.deleteAllAmount()
    }
    this.props.onToggle()
  }

  _handleToggle = () => {
    if ((this.props.isCloseable || this.state._trxId) && this.props.onToggle)
      this._deleteAmountBeforeClose()
  }

  _redirect = () => {
    this.props.history.push(`/user_dashboard/wallet-history`);
  }

  render() {
    const totalAmount = parseInt(this.props.amount) + parseInt(this.props.administrationFee);
    return (
      <div>
        <ModalOutOfStock
          isOpen={this.state._isOpenAlert}
          onToggle={this._handleOnToggleAlert}
          message="Oops! You have not completed your payment. Would you like to complete it now?"
          onButtonPrimaryClick={this._handleOnSubmitAlert}
          buttonPrimaryText="Proceed to payment completion"
          isCloseable
        />
        <Modal
          modalClassName="modal-topup-v3"
          isOpen={this.props.isOpen}
          toggle={this._handleToggle}
        >
          <div id='topup-container'>
            <div className='scrollable-wrapper'>
              <KickImage onClick={() => this._deleteAmountBeforeClose()} className='close-btn' src={RoundCloseButton} alt='close-btn' />
              <div className="topup-header snap-pay-header">
                {
                  (this.props.isCloseable || this.state._trxId) && this.props.onToggle ? (
                    <CloseButton onClick={this._handleToggle} />
                  ) : null
                }
                <p className='content-header-title'>{this.props.headerTitle}</p>
              </div>
              <div className="topup-content third-modal">
                <div className={classNames({ 'd-none': !this.props.dataMidtrans.isFetch })}>
                  <Loading
                    height={50}
                    width={50}
                  />
                </div>
                <div className={classNames("third-modal-content", { 'd-none': this.props.dataMidtrans.isFetch })}>
                  <p className='sub-header'>
                    {getStatusText(this.state._trxStatus)} {getStatusDetailText(this.state._trxStatus)}
                  </p>
                  <Icon
                    transactionStatus={this.state._trxStatus}
                    expiredAt={this.state._expiredAt}
                    onExpired={this._handleExpiredCountdown}
                    className="snappay-icon"
                  />
                  {
                    this.state._trxStatus === 'pending' ?
                      <>
                        <p className='payment-text'>
                          Please complete your payment before
                        </p>
                        <p className='timer-text'>{moment(this.state._expiredAt).format('dddd, LL HH:mm')}</p>
                      </>
                      : null

                  }
                  <div className="topup-header">
                    <div className="topup-payment-info">
                      <div className="amount-info">
                        <span>Amount to be paid</span>
                        <span style={{ color: '#159953' }}>IDR {convertToRupiah(parseInt(this.state._amount))}</span>
                      </div>
                      <ButtonCopy
                        hide={false}
                        value={parseInt(this.state._amount)}
                      >
                        <KickImage className='copy-icon' src={CopyIcon} alt="copy" />
                      </ButtonCopy>
                    </div>
                  </div>
                  {
                    this.state._vaNumber !== null && ['bank_transfer', 'echannel'].includes(this.state._paymentType) ?
                      <div className="topup-header va-header-wrapper">
                        <div className="topup-payment-info">
                          <div className="amount-info">
                            <span>{getSelectedPayment(this.state._paymentType, this.state._bank)}</span>
                            <span>{this.state._vaNumber}</span>
                          </div>
                          <ButtonCopy
                            hide={this.state._vaNumber && this.state._vaNumber.indexOf('X') > -1}
                            value={this.state._vaNumber}
                          >
                            <KickImage className='copy-icon' src={CopyIcon} alt="copy" />
                          </ButtonCopy>
                        </div>
                      </div>
                      : null
                  }
                  <div className="topup-instructions">
                    <div className="topup-instructions-info">
                      <KickImage className="icon-reminder" src={WarningGreen} />
                      <span>If you have any questions about your order, please contact our team by email to <a href="mailto:info@kickavenue.com" title="Mail to info@kickavenue.com">info@kickavenue.com</a>. Please put your invoice number into your subject email.</span>
                    </div>
                  </div>
                </div>
                {
                  !this.state._vaNumber ?
                    <p className='by-clicking-text'>By clicking this button, you have  agreed on our Terms and Conditions. You will be redirected to payment page provided by a secured 3rd party.</p>
                    :
                    null
                }
              </div>
            </div>
            <div className="topup-button snap-pay-button">
              <div className={`btn-wrapper ${this.state._vaNumber ? "" : "one-button"}`}>
                {this.state._vaNumber ? <button
                  onClick={() => {
                    this.props.pageSelling ? this._redirect() : this._deleteAmountBeforeClose()
                  }}
                  className='btn-payment-status'>
                  Check Payment Status
                </button> : null}
                <ButtonSnapPay
                  ref={input => this.buttonPayRef = input}
                  snapToken={this.state._trxToken}
                  disabled={this.state._trxToken === null}
                  hide={this.state._trxToken === null || this.state._trxStatus !== 'pending'}
                  className="btn-green bold"
                  color="success"
                  size="sm"
                  redirectUrl={this.props.redirectUrl}
                  onSuccess={this._handleOnSuccess}
                  onPending={this._handleOnPending}
                  onError={this._handleOnError}
                  onClose={this._handleOnToggleAlert}
                >
                  {
                    this.props.dataMidtrans.isFetch ?
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <ReactLoading type={'bars'} height={20} width={20} color="#fff" />
                        <span>
                          PLEASE WAIT
                        </span>
                      </div>
                      : (this.state._trxId ? HAS_CONFIRM_PAYMENT_MSG : NOT_CONFIRM_PAYMENT_MSG)
                  }
                </ButtonSnapPay>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getMidtransDetail: invoice => dispatch(doGetMidtransPaymentDetail(invoice))
})

const mapStateToProps = ({ dataPayment: { midtrans: { details } } }) => ({
  dataMidtrans: details
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ModalSnapPay));

ModalSnapPay.defaultProps = {
  isOpen: false,
  isCloseable: false,
  headerTitle: 'PAY NOW',
  paymentType: 'bank_transfer',
  autoOpenSnapModal: false
}

ModalSnapPay.propTypes = {
  dataMidtrans: propTypes.object.isRequired,
  expiredAt: propTypes.string,
  invoiceNumber: propTypes.string,
  headerTitle: propTypes.string,
  isOpen: propTypes.bool,
  isCloseable: propTypes.bool,
  autoOpenSnapModal: propTypes.bool,
  onToggle: propTypes.func,
  paymentType: propTypes.string,
  trxToken: propTypes.string,
  redirectUrl: propTypes.string
}